var _circle, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgProductPlatformOld = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "url(#paint0_linear_13997_56812)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.40859 7.69141C7.12969 7.79219 6.92344 7.97969 6.78984 8.25156L6.71484 8.40625L6.70781 11.5398L6.70312 14.6758H9.88828H13.0758L13.0828 12.4563L13.0898 10.2344L13.1531 10.0469C13.2328 9.81484 13.3664 9.60859 13.5445 9.44453C13.7156 9.28516 13.8398 9.2125 14.0766 9.12813L14.2617 9.0625L15.7805 9.05547L17.3016 9.04844L17.2922 8.72734C17.2852 8.41797 17.2805 8.39922 17.2055 8.24219C17.1 8.02656 16.9148 7.84141 16.6992 7.73594L16.5352 7.65625L12.0352 7.65156C7.64062 7.64688 7.53281 7.64688 7.40859 7.69141Z",
  fill: "white"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.1609 9.82656C13.9992 9.90625 13.9172 9.99297 13.8375 10.1641L13.7812 10.2812V13.2695V16.2578L13.8375 16.375C13.9172 16.5461 13.9992 16.6328 14.1609 16.7125L14.3039 16.7852H15.8906H17.4773L17.6203 16.7125C17.782 16.6328 17.8641 16.5461 17.9438 16.375L18 16.2578V13.2695V10.2812L17.9438 10.1641C17.8641 9.99297 17.782 9.90625 17.6203 9.82656L17.4773 9.75391H15.8906H14.3039L14.1609 9.82656ZM16.0641 10.8766C16.1648 10.9445 16.2188 11.0406 16.2188 11.1602C16.2188 11.2797 16.1648 11.3758 16.0641 11.4437C15.9211 11.5375 15.7078 11.4859 15.607 11.3336C15.5531 11.2516 15.5484 11.0898 15.5977 10.9984C15.675 10.8461 15.9188 10.7828 16.0641 10.8766ZM16.3992 15.0812C16.6242 15.2031 16.6266 15.5359 16.4016 15.6719C16.3313 15.7141 16.282 15.7188 15.8906 15.7188C15.4992 15.7188 15.45 15.7141 15.3797 15.6719C15.1688 15.5453 15.15 15.2359 15.3445 15.1094C15.45 15.0391 15.5297 15.0297 15.9375 15.0344C16.2492 15.0391 16.3383 15.0484 16.3992 15.0812Z",
  fill: "white"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.15469 15.4234C6.01641 15.5148 6 15.5687 6 15.9297C6 16.225 6.00703 16.2695 6.05625 16.375C6.13594 16.5461 6.21797 16.6328 6.37969 16.7125L6.52266 16.7852H9.90703H13.2891L13.2328 16.6727C13.1273 16.4641 13.0992 16.3094 13.0852 15.8289L13.0711 15.3789H9.64688C6.33281 15.3789 6.22031 15.3812 6.15469 15.4234Z",
  fill: "white"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_13997_56812",
  x1: 6.5,
  y1: 1,
  x2: 16,
  y2: 23,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EDD1C1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFBDE5"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgProductPlatformOld);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/product_platform_old.b517a6adf208f92db3aa44dba92b0c7e.svg";